import { FB_Template, MeasureConfig } from "@algomusinc/domain";
import { calcForecastMeasuresGDP } from "./calcForecastMeasuresGDP";
import { getColumnFormattedValue } from "./getColumnFormattedValue";
import { calcForecastMeasuresRDP } from "./calcForecastMeasuresRDP";
import { calculatePercentageChangeInMeasure } from "./calculatePercentageChangeInMeasure";
import { calculatePercentageInMeasure } from "./calculatePercentageInMeasure";
import { calculateMeasureTotal } from "./calculateMeasureTotal";

export const getMeasureFormattedValue = (
  column: any,
  gridComponent: any
) => {
  let measureCode = column.data.code;
  let fbForecastMIVResponseModelKey = 'fbForecastMIVResponseModel';
  let mivPlanners = [FB_Template.Multi_ItemView, FB_Template.Customer_Order_Planner, FB_Template.REPL_PLANNER, FB_Template.PP_Planner];
  let stellantisUrl = 'https://configapi-stellantis-demo.azurewebsites.net/api';
  let measureConfig = column.data.measureConfigData;
  if (gridComponent?.environmentUrl?.configuration === stellantisUrl) {
    let stellantisMeasureValue = calculateStellantisMeasures(column, measureCode, gridComponent.fbTemplateId);
    if (stellantisMeasureValue !== undefined && stellantisMeasureValue !== null) return stellantisMeasureValue;
  }
  if (mivPlanners.includes(gridComponent.fbTemplateId)) {
    if (column.data && column.data.code && column.data.code.split('--').length > 0) {
      measureCode = column.data.code.split('--')[1];
    }
    let mivMeasureValue = getMivFormattedValue(gridComponent.uiList, column, measureConfig, gridComponent.currencyCode, gridComponent.currency, gridComponent.percent);
    if (mivMeasureValue !== undefined && mivMeasureValue !== null) return mivMeasureValue;
  }
  if (column.data[column.colDef.field] !== undefined && column.data[column.colDef.field] !== null) {
    if (column.colDef.field !== 'Total') {
      let row;
      if (gridComponent.fbTemplateId !== FB_Template.REPL_PLANNER && gridComponent.fbTemplateId !== FB_Template.Customer_Order_Planner) {
        row = gridComponent.gridListUI.find((row: any) => row.title === column.colDef.field);
        if (mivPlanners.includes(gridComponent.fbTemplateId)) {
          let mivItemAccountIds = column.data.code.split('--');
          row = row[fbForecastMIVResponseModelKey].find((e: any) => e.channelId == mivItemAccountIds[3] && e.itemId == mivItemAccountIds[2]);
        }
      }
      if (measureConfig && measureConfig.isCalculatedFE && measureCode === 'GDPTotalForecast') {
        if (row[gridComponent.parentKey]['GDPBaselineFcst'] ) {
          let gdpValue = calcGDPForecastMeasures(mivPlanners, gridComponent.gridListUI, column.colDef.field, column.data.code, gridComponent.fbTemplateId, gridComponent.parentKey, fbForecastMIVResponseModelKey);
          gdpValue = !isNaN(Math.round(gdpValue)) ? Math.round(gdpValue) : Math.round(+column.data[column.colDef.field])
          return gdpValue >= 0 ? gdpValue.toLocaleString() : 0
        }
      }
        else if (measureConfig && measureConfig.isCalculatedFE && measureCode === 'RDPTotalForecast') {
        if (row[gridComponent.parentKey]['RDPBaselineFcst']) {
          let rdpValue = calcRDPForecastMeasures(mivPlanners, gridComponent.gridListUI, column.colDef.field, column.data.code, gridComponent.fbTemplateId, gridComponent.parentKey, fbForecastMIVResponseModelKey);
          rdpValue = !isNaN(Math.round(rdpValue)) ? Math.round(rdpValue) : Math.round(+column.data[column.colDef.field])
          return rdpValue >= 0 ? rdpValue.toLocaleString() : 0
        }
        }
      if (measureCode === 'PromoIndicatorComments') {
        if (column.data[column.colDef.field] && (column.data[column.colDef.field].toString().indexOf('Y--') > -1)) {
          let value = column.data[column.colDef.field].split('--');
          value = value[0];
          return value
        } else {
          return column.data[column.colDef.field] === '' ? 0 : column.data[column.colDef.field];
        }
      } else if (measureCode && measureCode.indexOf('Pct') > -1) {
        if (gridComponent.fbTemplateId === FB_Template.Split_Percentage) {
          let splitValue = getSplitFormattedValue(column, gridComponent.currencyCode, gridComponent.currency, gridComponent.percent);
          if (splitValue !== undefined && splitValue !== null) return splitValue;
        }
        return getColumnFormattedValue((column.data[column.colDef.field]), measureConfig, gridComponent.percent, gridComponent.currency, gridComponent.currencyCode);
      } else if (measureCode && measureCode.indexOf('Comment') < 0) {
        if (gridComponent.fbTemplateId === FB_Template.Split_Percentage) {
          let splitValue = getSplitFormattedValue(column, gridComponent.currencyCode, gridComponent.currency, gridComponent.percent);
          if (splitValue !== undefined && splitValue !== null) return splitValue;
        }
      }
      return getColumnFormattedValue((column.data[column.colDef.field]), measureConfig, gridComponent.percent, gridComponent.currency, gridComponent.currencyCode);
    } else {
      return calculateMeasureTotal(measureCode, gridComponent, column.data.code, column);
    }
  }
  return '';
}

function calcGDPForecastMeasures(mivPlanners: any, gridListUI: Array<any>, key: string, code: any, fbTemplateId: any, parentKey: any, fbForecastMIVResponseModelKey: any): any {
  if (mivPlanners.includes(fbTemplateId)) {
    let index = gridListUI.findIndex((row) => row.title === key);
    if (index > -1) {
      if (code && code.split('--').length > 0) {
        code = code.split('--');
        // Use the correct response model key (handles both MIV and DC grids)
        const responseModelKey = fbForecastMIVResponseModelKey || 'fbForecastMIVResponseModel';
        const responseModel = gridListUI[index]?.[responseModelKey];
        if (!responseModel || !Array.isArray(responseModel)) {
          return 0;
        }
        let mIVResponseModelIndex = responseModel.findIndex((e: any) =>
          e.itemId == code[2] && e.channelId == code[3]);
        if (mIVResponseModelIndex > -1) {
          return calcForecastMeasuresGDP(key, gridListUI, parentKey, mIVResponseModelIndex, fbTemplateId, fbForecastMIVResponseModelKey);
        }
      }
    }
  } else {
    return calcForecastMeasuresGDP(key, gridListUI, parentKey);
  }
}
function calcRDPForecastMeasures(mivPlanners: any, gridListUI: Array<any>, key: string, code: any, fbTemplateId: any, parentKey: any, fbForecastMIVResponseModelKey: any): any {
  if (mivPlanners.includes(fbTemplateId)) {
    let index = gridListUI.findIndex((row) => row.title === key);
    if (index > -1) {
      if (code && code.split('--').length > 0) {
        code = code.split('--');
        // Use the correct response model key (handles both MIV and DC grids)
        const responseModelKey = fbForecastMIVResponseModelKey || 'fbForecastMIVResponseModel';
        const responseModel = gridListUI[index]?.[responseModelKey];
        if (!responseModel || !Array.isArray(responseModel)) {
          return 0;
        }
        let mIVResponseModelIndex = responseModel.findIndex((e: any) =>
          e.itemId == code[2] && e.channelId == code[3]);
        if (mIVResponseModelIndex > -1) {
          return calcForecastMeasuresRDP(key, gridListUI, parentKey, mIVResponseModelIndex, fbTemplateId, fbForecastMIVResponseModelKey);
        }
      }
    }
  } else {
    return calcForecastMeasuresRDP(key, gridListUI, parentKey);
  }
}

function calculateStellantisMeasures(column: any, measureCode: any, fbTemplateId: any) {
  if (fbTemplateId == FB_Template.Dip_Top_Down_Planning && (measureCode == 'AccountUnconstrainedFWOS' || measureCode == 'AccountConstrainedFWOS')) {
    if (column.colDef.refData.isMonth) {
      return Math.round(column.data[column.colDef.field] / column.colDef.refData.weekList.length)
    }
    if (column.colDef.refData.isQuarter) {
      let weekCount = 0;
      column.colDef.refData.monthList.forEach((month: any) => {
        weekCount = weekCount + month.weekList.length
      });
      return Math.round(column.data[column.colDef.field] / weekCount)
    }
    if (column.colDef.refData.isHalf) {
      let weekCount = 0;
      column.colDef.refData.quarterList.forEach((quarter: any) => {
        quarter.monthList.forEach((month: any) => {
          weekCount = weekCount + month.weekList.length
        });
      });

      return Math.round(column.data[column.colDef.field] / weekCount)
    }
    if (column.colDef.refData.isYear) {
      let weekCount = 0;
      column.colDef.refData.halfList.forEach((half: any) => {
        half.quarterList.forEach((quarter: any) => {
          quarter.monthList.forEach((month: any) => {
            weekCount = weekCount + month.weekList.length
          });
        });
      });
      return Math.round(column.data[column.colDef.field] / weekCount)
    }
  }
  return undefined;
}

function getSplitFormattedValue(column: any, currencyCode: any, currency: any, percent: any) {
  let measureConfig = column.data.measureConfigData;
  let measureCode = column.data.code;
  if (measureCode.indexOf('Pct') > -1) {
    return column.data[column.colDef.field] == 'Multiple' ? column.data[column.colDef.field] : percent.transform(column.data[column.colDef.field] / 100, '1.2-2');
  } else if (measureCode.indexOf('Comment') < 0) {
    // measureCode = measureCode.split('--');
    if (measureCode.indexOf('Revenue') > -1) {
      return column.data[column.colDef.field] == 'Multiple' ? column.data[column.colDef.field] : currency.transform(column.data[column.colDef.field], currencyCode, 'symbol', '1.2-2')
    } else {
      if (measureConfig && measureConfig.isDecimal) {
        return measureConfig.decimalPlaces ? Number(column.data[column.colDef.field]).toFixed(measureConfig.decimalPlaces) : Number(column.data[column.colDef.field]).toFixed(2);
      } else {
        return Math.round(+column.data[column.colDef.field]).toLocaleString();
      }
    }
  }
}
function getMivFormattedValue(uiList: any, column: any, measureConfig: MeasureConfig, currencyCode: any, currency: any, percent: any) {
  let measureCode = column.data.code;
  if (column.data && measureCode && measureCode.split('--').length > 0) {
    measureCode = measureCode.split('--')[1];
  }
  if (column.colDef.field !== 'Total') {
    let columnData = measureCode?.split('--');
    if (measureCode === 'ChangeInFCPct') {
      const baselineFCMeasureId: number = 730;
      const updatedFCMeasureId: number = 731;
      const calculatedTotal: any = calculatePercentageChangeInMeasure(uiList, baselineFCMeasureId, updatedFCMeasureId, column, column.colDef.field);
      if (calculatedTotal != undefined) {
        column.data[column.colDef.field] = calculatedTotal * 100;
        return getColumnFormattedValue(calculatedTotal * 100, measureConfig, percent, currency, currencyCode)
      }

    } else if (measureCode == 'ChangeInProfitPct') {
      const baselineProfitMeasureId: number = 736;
      const updatedProfitMeasureId: number = 737;
      const calculatedTotal = calculatePercentageChangeInMeasure(uiList, baselineProfitMeasureId, updatedProfitMeasureId, column, column.colDef.field);
      if (calculatedTotal != undefined) {
        column.data[column.colDef.field] = calculatedTotal * 100;
        return getColumnFormattedValue(calculatedTotal * 100, measureConfig, percent, currency, currencyCode)
      }

    } else if (measureCode == 'ChangeInSalesRevenuePct') {
      const baselineSalesRevenueMeasureId: number = 733;
      const updatedSalesRevenueMeasureId: number = 734;
      const calculatedTotal = calculatePercentageChangeInMeasure(uiList, baselineSalesRevenueMeasureId, updatedSalesRevenueMeasureId, column, column.colDef.field);
      if (calculatedTotal != undefined) {
        column.data[column.colDef.field] = calculatedTotal * 100;
        return getColumnFormattedValue(calculatedTotal * 100, measureConfig, percent, currency, currencyCode)
      }
    }
    else if (measureCode == 'BaselineProfitMarginPct') {
      const baselineProfitMarginMeasureId: number = 736;
      const updatedSalesMeasureId: number = 733;
      const calculatedTotal = calculatePercentageInMeasure(uiList, baselineProfitMarginMeasureId, updatedSalesMeasureId, column, column.colDef.field);
      if (calculatedTotal != undefined) {
        column.data[column.colDef.field] = calculatedTotal * 100;
        return getColumnFormattedValue(calculatedTotal * 100, measureConfig, percent, currency, currencyCode)
      }
    }
    else if (measureCode == 'UpdatedProfitMarginPct') {
      const baselineProfitMarginMeasureId: number = 737;
      const updatedSalesMeasureId: number = 734;
      const calculatedTotal = calculatePercentageInMeasure(uiList, baselineProfitMarginMeasureId, updatedSalesMeasureId, column, column.colDef.field);
      if (calculatedTotal != undefined) {
        column.data[column.colDef.field] = calculatedTotal * 100;
        return getColumnFormattedValue(calculatedTotal * 100, measureConfig, percent, currency, currencyCode)
      }
    }
    else if (measureCode == 'ChangeInProfitMarginPct') {
      const baselineProfitMarginMeasureId: number = 903;
      const updatedSalesMeasureId: number = 904;
      const calculatedTotal = calculatePercentageChangeInMeasure(uiList, baselineProfitMarginMeasureId, updatedSalesMeasureId, column, column.colDef.field);
      if (calculatedTotal != undefined) {
        column.data[column.colDef.field] = calculatedTotal * 100;
        return getColumnFormattedValue(calculatedTotal * 100, measureConfig, percent, currency, currencyCode)
      }
    }
  }
}




